import React, { FC, useState } from 'react';
import { ButtonGroup } from '@material-ui/core';
import DateRangePicker from './components/DateRangePicker';
import Button from '../../../../../../components/Button';
import { FaCaretLeft as PreviousIcon } from '@react-icons/all-files/fa/FaCaretLeft';
import { FaCaretRight as NextIcon } from '@react-icons/all-files/fa/FaCaretRight';
import { createUseStyles } from '../../../../../../theming';
import moment from 'moment';
import Hidden from '../../../../../components/Hidden';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  actionsContainer: {
    display: 'flex',
    marginTop: 10,
    '& > div:first-child': {
      marginRight: 5,
    },
    '& > div:last-child': {
      marginLeft: 5,
    },
  },
});

interface Props {
  startDate: string | null;
  endDate: string | null;
  onStartDateChange: (date: string | null) => void;
  onEndDateChange: (date: string | null) => void;
}

type RangeType = 'month' | 'year' | 'week';

const DateRangeContainer: FC<Props> = ({ startDate, endDate, onStartDateChange, onEndDateChange }) => {
  const [range, setRange] = useState<RangeType>('month');
  const classes = useStyles();

  const handleSetPrevious = () => {
    let startMoment = startDate ? moment(startDate, 'YYYY-MM-DD') : moment();
    startMoment = startMoment.startOf(range).add(-1, range);

    onStartDateChange(startMoment.format('YYYY-MM-DD'));
    onEndDateChange(startMoment.endOf(range).format('YYYY-MM-DD'));
  };

  const handleSetNext = () => {
    let startMoment = startDate ? moment(startDate, 'YYYY-MM-DD') : moment();
    startMoment = startMoment.startOf(range).add(1, range);

    onStartDateChange(startMoment.format('YYYY-MM-DD'));
    onEndDateChange(startMoment.endOf(range).format('YYYY-MM-DD'));
  };

  const handleSetRange = (range: RangeType) => {
    const startMoment = moment();

    onStartDateChange(startMoment.startOf(range).format('YYYY-MM-DD'));
    onEndDateChange(startMoment.endOf(range).format('YYYY-MM-DD'));

    setRange(range);
  };

  return (
    <div className={classes.root}>
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
      />

      <div className={classes.actionsContainer}>
        <ButtonGroup>
          <Button
            onClick={() => handleSetRange('week')}
            type='button'
            variant={range === 'week' ? 'contained' : 'outlined'}
            color='primary'
          >
            Semaine
          </Button>
          <Button
            onClick={() => handleSetRange('month')}
            type='button'
            variant={range === 'month' ? 'contained' : 'outlined'}
            color='primary'
          >
            Mois
          </Button>
          <Button
            onClick={() => handleSetRange('year')}
            type='button'
            variant={range === 'year' ? 'contained' : 'outlined'}
            color='primary'
          >
            Année
          </Button>
        </ButtonGroup>

        <Hidden smDown>
          <ButtonGroup>
            <Button variant='outlined' color='primary' onClick={handleSetPrevious}>
              <PreviousIcon size={15} />
            </Button>
            <Button variant='outlined' color='primary' onClick={handleSetNext}>
              <NextIcon size={15} />
            </Button>
          </ButtonGroup>
        </Hidden>
      </div>
    </div>
  );
};

export default DateRangeContainer;
